import { Media } from '@interfaces/MyLesson'
import groupBy from 'lodash/groupBy'
import toPairs from 'lodash/toPairs'
import zipObject from 'lodash/zipObject'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { Col, Row } from 'react-styled-flexboxgrid'
import { GroupMediaProp } from './interface'
import { StyledCol, FileContainer, Info, Label, MediaCol, MediaP, StyledRow } from './style'
import { getIcon } from './utils'

const GroupMedia: React.FC<GroupMediaProp> = ({ medias }) => {
  const pairs = toPairs(groupBy(medias, 'Owner'))
  const groupByOwner = pairs.map(pair => zipObject(['Owner', 'List'], pair))

  return (
    <>
      {medias.length > 1 && (
        <Row>
          <MediaCol xs={12} md={12}>
            <Label>
              <FormattedMessage id="Uploaded Media" />:
            </Label>
          </MediaCol>
          <Col xs={12} md={6}>
            <Row>
              {groupByOwner.map(group => {
                const groupList = group.List as Array<Media>
                return (
                  <StyledCol xs={12} md={6} key={group.Owner.toString()}>
                    <MediaP>{group.Owner}</MediaP>
                    <StyledRow>
                      <Row>
                        {groupList.map(media => {
                          const { Icon } = getIcon(media.Type)
                          return (
                            <StyledCol key={media.Name} xs={12} md={6}>
                              <FileContainer>
                                <Icon size="sm" />
                                <Info>{media.Name}</Info>
                              </FileContainer>
                            </StyledCol>
                          )
                        })}
                      </Row>
                    </StyledRow>
                  </StyledCol>
                )
              })}
            </Row>
          </Col>
        </Row>
      )}
    </>
  )
}

export default GroupMedia
